import { render, staticRenderFns } from "./Ambulatorio.vue?vue&type=template&id=14fd1398&scoped=true"
import script from "./Ambulatorio.vue?vue&type=script&lang=js"
export * from "./Ambulatorio.vue?vue&type=script&lang=js"
import style0 from "./Ambulatorio.vue?vue&type=style&index=0&id=14fd1398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd1398",
  null
  
)

export default component.exports